import BaseApi from './base'

class CardMarketplace extends BaseApi {
  getCardMarketplaces = (query) =>
    this.client.get(`admin/scw-card-marketplace?${query}`)

  getCardMarketplace = (id) =>
    this.client.get(`admin/scw-card-marketplace/${id}`)

  addCardMarketplace = (data) =>
    this.client.post('admin/scw-card-marketplace', data)

  updateCardMarketplace = (id, data) =>
    this.client.patch(`admin/scw-card-marketplace/${id}`, data)

  deleteCardMarketplace = (id) =>
    this.client.delete(`admin/scw-card-marketplace/${id}`)

  addCardMarketplaceContent = (id, data) =>
    this.client.post(
      `admin/scw-card-marketplace/${id}/content/${data?.languageId}`,
      data
    )

  getShowcaseContents = (id) =>
    this.client.get(`admin/scw-card-marketplace/${id}/contents`)

  changeCardMarketplaceStatus = (id, data) =>
    this.client.patch(`admin/scw-card-marketplace/${id}/status`, data)
}

export default new CardMarketplace()
